import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueMeta from 'vue-meta'
import ToolListCard from '@/components/ToolListCard.vue'
import './assets/css/global.css'

Vue.use(VueMeta)
Vue.component('ToolListCard', ToolListCard)
import { userFacingGenerationError } from '@/utils/userFacingGenerationError'
import { getFriendlyErrorSummaryFromDetail } from '@/utils/errorSummaryCategorizer'

Vue.config.productionTip = false

var AI_ERROR_CLASSIFY_COMPONENTS = {
  ImageGeneratorNew: true,
  VideoGeneratorNew: true,
  AppDetail: true,
  Music: true
}

Vue.prototype.$userFacingError = function(source, fallback, options) {
  var fb = fallback != null ? fallback : (this.$t ? this.$t('common.generateFailedContactSupport') : '')
  var detail = userFacingGenerationError(source, '')
  var normalizedDetail = detail != null ? String(detail).trim() : ''
  var compName = this && this.$options ? this.$options.name : ''
  var shouldClassify = !!AI_ERROR_CLASSIFY_COMPONENTS[compName]
  if (typeof options === 'boolean') {
    shouldClassify = options
  } else if (options && typeof options === 'object' && options.classify != null) {
    shouldClassify = !!options.classify
  }

  // Non-AI interfaces: show original message directly.
  var summary = normalizedDetail || fb
  try {
    if (shouldClassify && this.$t && normalizedDetail) {
      summary = getFriendlyErrorSummaryFromDetail(normalizedDetail, this.$t.bind(this), fb)
    }
  } catch (e) {}

  // Store on the component instance so the global watcher can read it right after generateError/formError/processError changes.
  this.__lastUserFacingErrorDetail = normalizedDetail
  this.__hasUserFacingErrorDetail = !!normalizedDetail

  return summary
}

var LEAVE_NOTICE_ROUTES = {
  ImageGeneratorNew: true,
  VideoGeneratorNew: true,
  AppDetail: true,
  Music: true,
  WatermarkRemoverDetail: true,
  BackgroundRemoverDetail: true,
  InpaintDetail: true,
  ImageEnhancerDetail: true,
  DocCropEnhanceDetail: true,
  HandwrittenEraseDetail: true
}

Vue.mixin({
  created: function() {
    var self = this
    var routeQuery = this.$route && this.$route.query ? this.$route.query : null
    if (routeQuery && routeQuery.prompt != null) {
      var promptText = String(routeQuery.prompt).trim()
      var dataObj = this.$data || {}
      if (promptText && Object.prototype.hasOwnProperty.call(dataObj, 'prompt') && !this.prompt) {
        this.prompt = promptText
      }
    }
    var data = this.$data || {}
    var watchedKeys = ['generateError', 'formError', 'processError', 'errorMessage']

    watchedKeys.forEach(function(key) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) return
      self.$watch(key, function(val) {
        if (!val) return
        if (!self.$store || !self.$store.dispatch) return
        var detailMessage = ''
        if (self.__hasUserFacingErrorDetail && self.__lastUserFacingErrorDetail) {
          detailMessage = self.__lastUserFacingErrorDetail
        }
        // Prevent stale details from being displayed for later validation errors.
        self.__hasUserFacingErrorDetail = false
        self.__lastUserFacingErrorDetail = ''
        self.$store.dispatch('showErrorModal', {
          title: self.$t ? self.$t('common.error') : 'Error',
          message: String(val),
          detailMessage: detailMessage
        })
      })
    })
  },
  beforeRouteLeave: function(to, from, next) {
    next()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted: function() {
    // 触发预渲染完成事件
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
